'use es6';

import Domain from '../models/Domain';
import { REQUESTED_DOMAIN, RECEIVED_DOMAIN, REQUESTED_DOMAIN_FAILED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new Domain(), action) => {
  switch (action.type) {
    case REQUESTED_DOMAIN:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_DOMAIN:
      return new Domain(Object.assign({}, action.payload.domain, {
        status: RequestStatus.SUCCEEDED
      }));
    case REQUESTED_DOMAIN_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});